// @flow
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const ContentBlocksSection = styled.section`
  max-width: 100%;
  margin: 24px 0 40px;
  font-size: 16px;
  line-height: 1.7;
  color: #444;

  h2 {
    font-size: 26px;
    font-weight: 700;
    line-height: 1.3;
    color: #1a1a1a;
    margin: 32px 0 16px;

    &:first-child {
      margin-top: 0;
    }
  }

  h3 {
    font-size: 19px;
    font-weight: 700;
    line-height: 1.4;
    color: #1a1a1a;
    margin: 24px 0 10px;
  }

  p {
    margin: 0 0 1.1em;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    margin: 0 0 1.1em;
    padding-left: 22px;

    li {
      margin-bottom: 6px;
    }
  }

  a {
    color: ${({ theme }) => theme.plus.secondaryL};
    text-decoration: underline;
  }

  strong {
    color: #1a1a1a;
  }

  ${maxMediaQueries.tablet`
    margin: 20px 0 32px;
    font-size: 15px;

    h2 {
      font-size: 22px;
    }

    h3 {
      font-size: 18px;
    }
  `};
`;

export const ContentIntro = styled.div`
  max-width: 100%;
  margin: 0 0 24px;
  font-size: 17px;
  line-height: 1.6;
  color: #444;

  p {
    margin: 0 0 1em;

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    color: #1a1a1a;
  }

  a {
    color: ${({ theme }) => theme.plus.secondaryL};
    text-decoration: underline;
  }

  ${maxMediaQueries.tablet`
    font-size: 16px;
  `};
`;
